export const EVENT_AUTOCOMPLETE_AFFILIATE = 'ebdssbeac';

export const DESTINATION_CITY_BROWSE_SLA_MILLISECONDS = 4000; // 2x the P95 of the destination/city_browse/ endpoint
export const DESTINATION_RECOMMENDATIONS_SLA_MILLISECONDS = 7000; // 2x the P95 of the destination/users/me/recommendations/ endpoint
export const DESTINATION_RELATED_EVENTS_SLA_MILLISECONDS = 1500; // 2x the P95 of the /destination/events/${event.id}/related/ endpoint
